import React, { useState } from 'react';

const DocumentationModal = ({ isOpen, onClose, integration }) => {
    const [search, setSearch] = useState('');

    if (!isOpen || !integration) return null;

    const links = integration.documentation_links || [];
    const filteredLinks = links.filter(link =>
        link.title.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <>
            {/* Overlay */}
            <div className="fixed inset-0 bg-black/50 z-30" onClick={onClose}></div>

            {/* Modal */}
            <div className="fixed right-0 top-0 h-screen w-full max-w-md bg-white dark:bg-gray-800 shadow-lg z-40 flex flex-col">
                {/* Header */}
                <div className="p-6 border-b border-gray-200 dark:border-gray-700 flex-shrink-0">
                    <div className="flex items-center justify-between">
                        <div>
                            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Documentação</h2>
                            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{integration.name}</p>
                            <div className="flex flex-wrap gap-1.5 mt-2">
                                {integration.supplier?.name && (
                                    <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200">
                                        {integration.supplier.name}
                                    </span>
                                )}
                                {integration.system?.description && (
                                    <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-200">
                                        {integration.system.description}
                                    </span>
                                )}
                                {integration.system?.system_type?.name && (
                                    <span className="inline-block px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-200">
                                        {integration.system.system_type.name}
                                    </span>
                                )}
                            </div>
                        </div>
                        <button
                            onClick={onClose}
                            className="p-1 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition"
                        >
                            <span className="material-icons sm">close</span>
                        </button>
                    </div>
                </div>

                {/* Content */}
                <div className="flex-grow overflow-y-auto">
                    <div className="p-6">
                        {links.length > 0 && (
                            <input
                                type="text"
                                placeholder="Pesquisar documentação..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="w-full mb-4 px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        )}
                        {filteredLinks.length === 0 ? (
                            <div className="text-center py-8">
                                <span className="material-icons text-gray-400 dark:text-gray-500 text-4xl mb-2">help_outline</span>
                                <p className="text-gray-500 dark:text-gray-400 text-sm">{search ? 'Nenhum resultado encontrado' : 'Nenhuma documentação disponível'}</p>
                            </div>
                        ) : (
                            <div className="space-y-3">
                                {filteredLinks.map((link, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center justify-between gap-4 p-4 border border-gray-200 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700/30"
                                    >
                                        <div className="flex items-center gap-3 min-w-0">
                                            <span className="material-icons text-blue-500 flex-shrink-0">description</span>
                                            <span className="text-sm font-medium text-gray-900 dark:text-white truncate">{link.title}</span>
                                        </div>
                                        <button
                                            onClick={() => window.open(link.url, '_blank', 'noopener,noreferrer')}
                                            className="flex-shrink-0 flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-gray-800 border border-blue-500 hover:border-blue-600 text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300 dark:border-blue-400 text-xs font-medium rounded transition"
                                            title={`Abrir: ${link.url}`}
                                        >
                                            <span className="material-icons" style={{fontSize: '14px'}}>open_in_new</span>
                                            Abrir
                                        </button>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-gray-200 dark:border-gray-700 flex-shrink-0 bg-gray-50 dark:bg-gray-700/30">
                    <div className="flex items-center justify-center gap-2">
                        <span className="text-sm text-gray-700 dark:text-gray-300">Total de documentos disponíveis</span>
                        <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 text-xs font-semibold">{search ? filteredLinks.length : links.length}</span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DocumentationModal;
